import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=10eb59ec&scoped=true&"
import script from "./Root.vue?vue&type=script&lang=js&"
export * from "./Root.vue?vue&type=script&lang=js&"
import style0 from "./Root.vue?vue&type=style&index=0&id=10eb59ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eb59ec",
  null
  
)

export default component.exports